import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try {
      const { data } = await api.get("/wishlist");
      setIds(data.map((p) => p.product_id));
    } catch (err) { console.warn("wishlist load failed", err); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const has = useCallback((product_id) => ids.includes(product_id), [ids]);

  const toggle = useCallback(async (product) => {
    if (!user) { toast.error("Log in to save to wishlist"); return; }
    try {
      if (ids.includes(product.product_id)) {
        await api.delete(`/wishlist/${product.product_id}`);
        setIds((prev) => prev.filter((id) => id !== product.product_id));
        toast.success("Removed from wishlist");
      } else {
        await api.post(`/wishlist/${product.product_id}`);
        setIds((prev) => [...prev, product.product_id]);
        toast.success("Saved to wishlist");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    }
  }, [ids, user]);

  const value = useMemo(() => ({ ids, has, toggle, refresh }), [ids, has, toggle, refresh]);
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}
